import { AlertTriangle } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

export const ModerationTab = ({ reports, reportFilter, setReportFilter, onUpdateReport }) => (
  <div>
    <div className="flex items-center gap-2 mb-4">
      <select
        value={reportFilter}
        onChange={(e) => setReportFilter(e.target.value)}
        className="input-minimal w-auto"
        data-testid="report-filter"
      >
        <option value="open">Open Reports</option>
        <option value="reviewed">Reviewed</option>
        <option value="resolved">Resolved</option>
        <option value="dismissed">Dismissed</option>
        <option value="all">All Reports</option>
      </select>
    </div>

    <div className="space-y-3">
      {reports.length === 0 ? (
        <div className="glass-card p-8 text-center">
          <AlertTriangle className="w-12 h-12 text-[#3F3F46] mx-auto mb-3" />
          <p className="text-[#A1A1AA]">No reports found</p>
          <p className="text-xs text-[#52525B] mt-1">All clear! No user reports to review.</p>
        </div>
      ) : (
        reports.map((report) => (
          <div key={report.report_id} className="glass-card p-4">
            <div className="flex items-start justify-between">
              <div className="flex gap-4 flex-1">
                {report.report_type === "listing" && report.listing_photo && (
                  <div className="w-16 h-16 rounded-lg bg-[#18181B] overflow-hidden flex-shrink-0">
                    <img src={report.listing_photo} alt="" className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span
                      className={`px-2 py-0.5 text-xs rounded ${
                        report.report_type === "listing"
                          ? "bg-[#3B82F6]/10 text-[#3B82F6]"
                          : "bg-[#8B5CF6]/10 text-[#8B5CF6]"
                      }`}
                    >
                      {report.report_type === "listing" ? "Listing Report" : "Thread Report"}
                    </span>
                    <span
                      className={`px-2 py-0.5 text-xs rounded capitalize ${
                        report.reason === "animal_welfare"
                          ? "bg-[#EF4444]/10 text-[#EF4444]"
                          : report.reason === "fraud" || report.reason === "scam"
                          ? "bg-[#F59E0B]/10 text-[#F59E0B]"
                          : "bg-[#27272A] text-[#A1A1AA]"
                      }`}
                    >
                      {report.reason.replace(/_/g, " ")}
                    </span>
                    <StatusBadge status={report.status} />
                  </div>

                  {report.report_type === "listing" ? (
                    <>
                      <p className="text-[#EDEDED] font-medium">{report.listing_title}</p>
                      <p className="text-xs text-[#71717A]">
                        {report.listing_species} • Reported by {report.reporter_name}
                      </p>
                    </>
                  ) : (
                    <p className="text-[#EDEDED]">
                      {report.reporter_name} reported {report.reported_user_name}
                    </p>
                  )}

                  {report.details && (
                    <p className="text-sm text-[#A1A1AA] mt-2 p-2 bg-[#18181B] rounded">
                      "{report.details}"
                    </p>
                  )}

                  <p className="text-xs text-[#52525B] mt-2">
                    {new Date(report.created_at).toLocaleString()}
                  </p>
                </div>
              </div>

              {report.status === "open" && (
                <div className="flex flex-col gap-2 ml-4">
                  {report.report_type === "listing" && (
                    <>
                      <button
                        onClick={() => onUpdateReport(report.report_id, "resolved", "flag_listing")}
                        className="px-3 py-1.5 text-xs rounded-lg bg-[#F59E0B]/10 text-[#F59E0B] hover:bg-[#F59E0B]/20 transition-colors"
                        data-testid={`flag-listing-${report.report_id}`}
                      >
                        Flag Listing
                      </button>
                      <button
                        onClick={() => onUpdateReport(report.report_id, "resolved", "remove_listing")}
                        className="px-3 py-1.5 text-xs rounded-lg bg-[#EF4444]/10 text-[#EF4444] hover:bg-[#EF4444]/20 transition-colors"
                        data-testid={`remove-listing-${report.report_id}`}
                      >
                        Remove Listing
                      </button>
                    </>
                  )}
                  <button
                    onClick={() => onUpdateReport(report.report_id, "dismissed")}
                    className="px-3 py-1.5 text-xs rounded-lg border border-[#3F3F46] text-[#A1A1AA] hover:border-[#52525B] transition-colors"
                    data-testid={`dismiss-report-${report.report_id}`}
                  >
                    Dismiss
                  </button>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  </div>
);
